<template>
  <v-card flat class="h-100">
    <ImageCrop
      ref="crop"
      :src="cropperImage.image"
      @change="handleImageCrop"
    ></ImageCrop>
    <v-row class="mx-4 mt-4 pt-3">
      <v-img
        aspect-ratio=".8"
        :src="image.image"
        max-height="475px"
        max-width="380px"
      >
      </v-img>
    </v-row>
    <v-row class="mx-0 mr-4">
      <v-btn text class="ma-2" @click="$refs.crop.show()" :disabled="image.image === noImageSrc">
        <v-icon dark left>mdi-crop</v-icon>
        Crop
      </v-btn>
      <v-file-input
        :rules="rules"
        v-model="file"
        accept="image/png, image/jpeg"
        prepend-icon="mdi-camera"
        label="Display Image"
        @change="createImage"
      ></v-file-input>
    </v-row>
  </v-card>
</template>

<script>
import ImageCrop from '../../../../core/components/core/ImageCrop'

export default {
  name: 'EventsImageCard',
  components: {
    ImageCrop
  },
  props: {
    src: {
      type: String,
      default: ''
    }

  },
  data() {
    const noImageSrc = require('../../assets/no-image-selected.jpg');
    return {
      image: {image: this.src || noImageSrc},
      cropperImage: {image: this.src || ''},
      file: undefined,
      noImageSrc: noImageSrc,
      rules: [
        value => !value || value.size < 2000000 || 'Image should be less than 2MB',
      ],
    }
  },
  watch: {
    src(newValue) {
      this.image.image = newValue;
    },
    image: {
      deep: true,
      handler() {
        if (this.image.image === this.noImageSrc)
          this.$emit('update:src', '')
        else
          this.$emit('update:src', this.image.image)

        if (this.image.image === '')
          this.image.image = this.noImageSrc;
      }
    }
  },
  methods: {
    handleImageCrop(updatedSrc) {
      if (!updatedSrc)
        return;

      this.image.image = updatedSrc;
    },
    createImage(file) {

      if (file == null) {
        this.image.image = '';
        this.cropperImage.image = '';
        return;
      }

      let reader = new FileReader();

      let image = this.image;
      let cropperImage = this.cropperImage;

      reader.onload = (e) => {
        image.image = e.target.result;
        cropperImage.image = e.target.result;
      };

      reader.readAsDataURL(file);
    },
  }
}
</script>
<style>

</style>
